/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Row, Col, Image, Space } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Switch } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from './ListTable';
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import gstActions from "../../../../Admin/Setup/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import moment from 'moment';
import dayjs from 'dayjs';
import FileUpload from "../../../../Shared/components/FileUpload";


const Products = (props) => {
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [productId, setProductId] = useState('');
    const [visible, setVisible] = useState(false);
    const [useMrp, setUseMrp] = useState(false);
    const [data, setData] = useState({});

    const { editDetails, editError, editLoader, createDetails, createError, createData, createLoader } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;

    const { productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { catalogueDetails, categoryDetails, productDetails, productLoader } = useSelector(state => state.younoteAdminProductReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [product, setProduct] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const [error, setError] = useState({});

    const [form, setForm] = useState({
        "status": "ACTIVE",
        "useMrp": false
    });


    const dispatch = useDispatch();

    const handleOpen = () => {
        setProductId('');
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const onEdit = (data) => {
        setView(false);
        handleOpen();
        setProductId(data.id);
        setData(data);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogueId,
            "imageUri": data?.imageUri,
            "categoryId": data?.categoryId,
            "hsnId": data?.hsnId,
            "skuUnitId": data?.skuUnitId,
            "salesUnitId": data?.salesUnitId,
            "skuQuantity": data?.skuQuantity,
            'productGstId': data?.productGstId,
            "status": data?.status,
            "mrp": data?.mrp,
            'useMrp': data?.useMrp || false,
            "barcode": data?.barcode || '',
            'ianNumber': data?.ianNumber || '',
            "priceIncludesTax": data?.priceIncludesTax,
            "mrpLastUpdatedDate": data?.mrpLastUpdatedDate ? dayjs(data?.mrpLastUpdatedDate).$d : '',
        });
        hsnApi('', data?.hsnId);
        changeCatalogueHandler(parseInt(data?.catalogueId));
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setProductId(data.id);
        setProduct(data.productName);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            // if (name === 'hsnId') {
            //     let a = hsnDetails?.length > 0 && hsnDetails.filter(function (el) { return el.id === e });
            //     if (a && a?.length !== 0) {
            //         setForm({
            //             ...form,
            //             [name]: e,
            //             'productGstId': a[0].productGstId
            //         });
            //     }
            // } else {
            //     setForm({
            //         ...form,
            //         [name]: e,
            //     });
            // }
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'number' ? parseFloat(e.target.value) : e.target.value,
            });
        }
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Universal Products', history, 'Younote Admin')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({
                type: actions.CLEAR_ADMIN_PRODUCT_DETAILS_START,
            });
        };
    }, [roleManagement]);

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        if (id !== '') {
            filter['or'].push({ id: id });
        }
        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'id desc',
                limit: 500,
                skip: 0
            },
        });
    }

    const loadTasks = useCallback(() => {
        hsnApi('');
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.CATALOGUE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        // dispatch({ type: actions.CATEGORY_DETAILS_START });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ type: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ skuQuantity: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'universal-products',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setForm({
            'status': "ACTIVE",
            'useMrp': false
        });
        setCategoryList([]);
    };

    const onExport = () => {
        loadImportExportData('Universal Product');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.PRODUCT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const createProduct = (e) => {
        e.preventDefault();
        let emptyProductId = emptyValidation('Product ID', form.productId);
        let emptyProductName = emptyValidation('Product Name', form.productName);
        let emptyType = emptyValidation('Type', form.type, 'dropDown');
        let emptySkuQuantity = emptyValidation('SKU Quantity', form.skuQuantity);
        let emptySkuUnitId = emptyValidation('SKU Unit', form.skuUnitId, 'dropDown');
        let emptySalesUnitId = emptyValidation('Sales Unit', form.salesUnitId, 'dropDown');
        let emptyMrp = emptyValidation('MRP', form.mrp);
        let sku = true;
        let price = true;
        if (form.type === 'ITEM' && !emptySkuQuantity.isValid) {
            sku = false;
        }
        if (form.useMrp && !emptyMrp.isValid) {
            price = false;
        }
        emptyState();
        if (emptyProductName.isValid
            && emptyProductId.isValid &&
            emptyType.isValid && sku && emptySkuUnitId.isValid && emptySalesUnitId.isValid && price) {
            // if (useMrp) {
            //     form.useMrp = useMrp;
            // }
            if (form.latestPurchasePrice) {
                form.latestPurchasePrice = parseFloat(form.latestPurchasePrice);
            }
            if (form.mrp) {
                form.mrp = parseFloat(form.mrp);
            }
            if (form.categoryId) {
                let a = customObject(categoryList, form?.categoryId);
                if (a && a?.brandId) {
                    form.brandId = a?.brandId;
                }
            }
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: productId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "universal-products",
                title: "Universal Products",
                id: productId,
                details: data
            })
        } else {
            setError({
                'productId': emptyProductId.errors,
                'productName': emptyProductName.errors,
                'type': emptyType.errors,
                'skuQuantity': form.type === 'ITEM' && emptySkuQuantity.errors ? emptySkuQuantity.errors : '',
                'skuUnitId': emptySkuUnitId.errors,
                'salesUnitId': emptySalesUnitId.errors,
                'mrp': useMrp && emptyMrp.errors,
            });
        }
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(`"${createData.productName}" has been added successfully`);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (text.includes("UNIVERSL_PRODUCT_ID_UNIQUE")) {
                setError({
                    ...error,
                    "productId": "ProductId already exits"
                })
            }
            if (text.includes("UNIVERSL_PRODUCT_UNIQUE")) {
                setError({
                    ...error,
                    "productName": "Product Name already exits"
                })
            }
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(`"${form.productName}" has been updated successfully`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("UNIVERSL_PRODUCT_ID_UNIQUE")) {
                setError({
                    ...error,
                    "productId": "ProductId already exits"
                })
            }
            if (text.includes("UNIVERSL_PRODUCT_UNIQUE")) {
                setError({
                    ...error,
                    "productName": "Product Name already exits"
                })
            }
        }
    }, [editDetails, editError]);


    const handleAddMore = (e) => {
        createProduct(e);
        setAddMore(true);
        hsnApi();
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const handleAdd = () => {
        setView(false);
        handleOpen();
        hsnApi();
    }

    const onView = (data) => {
        setView(true);
        handleOpen();
        setProductId(data.id);
        setData(data);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogue?.catalogueName,
            "imageUri": data?.imageUri || '',
            "categoryId": data?.category?.categoryName,
            "hsnId": data?.hsn?.hsnCode,
            "productGstId": data?.productGst?.code,
            "skuUnitId": data?.skuUnit?.name,
            "salesUnitId": data?.salesUnit?.name,
            "skuQuantity": parseInt(data?.skuQuantity),
            "status": data?.status,
            "mrp": data?.mrp,
            "priceIncludesTax": data?.priceIncludesTax,
            "barcode": data?.barcode || '',
            'ianNumber': data?.ianNumber || '',
            "latestPurchasePrice": data?.latestPurchasePrice || '',
            "latestPurchasePriceTs": data?.latestPurchasePriceTs ? dayjs(data?.latestPurchasePriceTs).$d : '',
            "mrpLastUpdatedDate": data?.mrpLastUpdatedDate ? dayjs(data?.mrpLastUpdatedDate).$d : '',
        });
        setUseMrp(data?.useMrp);
    }

    useEffect(() => {
        let a = categoryDetails.length > 0 ? categoryDetails.filter((el) => { return !el.hasSubCategories }) : [];
        setCategoryList(a);
    }, [categoryDetails]);

    const changeCatalogueHandler = (id, form = false) => {
        dispatch({
            type: actions.CATEGORY_DETAILS_START, filter: {
                where: { ["and"]: [{ catalogueId: id }] }
            }
        });

        if (form) {
            changeHandler(id, 'catalogueId');
        }
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Universal Products', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Universal Products'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Universal Products', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Universal Products', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Universal Products', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Universal Products', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                unit={unitMesurementdetails}
                                hsn={hsnDetails}
                                productGst={productGstdetails}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onView={(data) => onView(data)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${productId ? `${view ? 'View' : 'Edit'}` : 'Add'} Product`}
                width={'690px'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createProduct(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col xxl={16} xl={16} lg={16} md={16} sm={12} xs={24}>
                                    <Row type="flex">
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product ID</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productId}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label={["Product ID ", <span key={"Product ID"} className={classes.colorRedRequired}> *</span>]}
                                                        variant={'standard'}
                                                        className={''}
                                                        error={error.productId ? true : false}
                                                        helperText={error.productId}
                                                        name={"productId"}
                                                        fullWidth
                                                        value={form?.productId || ''}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Name</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.productName}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label={["Product Name ", <span key={"Product Name"} className={classes.colorRedRequired}> *</span>]}
                                                        variant={'standard'}
                                                        className={clsx(classes.margin20t)}
                                                        error={error.productName ? true : false}
                                                        helperText={error.productName}
                                                        name={"productName"}
                                                        fullWidth
                                                        value={form?.productName || ''}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ?
                                                    <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                                    </> :
                                                    <TextField autoComplete='one-time-code'
                                                        label='Description'
                                                        name={"description"}
                                                        value={form?.description || ''}
                                                        multiline
                                                        error={error.description ? true : false}
                                                        helperText={error.description}
                                                        variant="outlined"
                                                        fullWidth
                                                        className={clsx(classes.margin20t, classes.customDescription)}
                                                        rows={2}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColor,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    />
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={!view ? 24 : 16} className={classes.feature} style={{ height: "100%" }}>
                                    <div className={clsx(classes.productImageUpload)}>
                                        <div className={classes.productImageUploadInner}>
                                            <FileUpload
                                                filePath={form?.imageUri || ''}
                                                handleChange={(value) => changeHandler(value, 'imageUri')}
                                                types={'image/jpeg,image/png,image/gif'}
                                                path={`younote/universalproduct/`}
                                                maxSize={1}
                                                text={<></>}
                                                alt={form?.productName}
                                                view={view}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row type="flex" gutter={40} className={classes.younoteAdminProduct}>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.catalogueId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Catalogue Name"]}
                                                heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                                                { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                                                details={catalogueDetails}
                                                parentValue={customObject(catalogueDetails, form?.catalogueId)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeCatalogueHandler(data.id, true)}
                                                parentError={error.catalogueId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.categoryId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Category Name"]}
                                                heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                                { 'key': 'parentName', 'name': 'Parent' },
                                                { 'key': 'level', 'name': 'Levels', 'suffix': "Level " }]}
                                                details={categoryList}
                                                parentValue={customObject(categoryList, form?.categoryId)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeHandler(data.id, 'categoryId')}
                                                parentError={error.categoryId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Type</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.type || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Product Type ", <span key={"Product Type"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'id', 'name': 'Product Type' }]}
                                                details={[{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }]}
                                                parentValue={customObject([{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }], form.type)}
                                                onChange={(data) => changeHandler(data.id, 'type')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.type}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.skuQuantity}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={form?.type === 'ITEM' ? ["SKU Quantity ", <span key={"SKU Quantity"} className={classes.colorRedRequired}> *</span>] : "SKU Quantity"}
                                                variant={'standard'}
                                                fullWidth
                                                className={clsx(classes.margin20t)}
                                                name={"skuQuantity"}
                                                value={form?.skuQuantity}
                                                type={'number'}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                                error={error.skuQuantity ? true : false}
                                                helperText={error.skuQuantity}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.skuUnitId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["SKU Unit ", <span key={"SKU Unit"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                parentValue={customObject(unitMesurementdetails, form?.skuUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'skuUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.skuUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.salesUnitId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Sales Unit ", <span key={"Sales Unit"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                parentValue={customObject(unitMesurementdetails, form?.salesUnitId)}
                                                onChange={(data) => changeHandler(data.id, 'salesUnitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.salesUnitId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product GST Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productGstId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Product GST Code"]}
                                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                                details={productGstdetails}
                                                parentValue={customObject(productGstdetails, form?.productGstId)}
                                                onChange={(data) => changeHandler(data.id, 'productGstId')}
                                                position={"bottom"}
                                                topPosition={true}
                                                customClasses={classes.margin20t}
                                                parentError={error.productGstId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.status}</Typography>
                                            </> :
                                            <FormControl
                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton)}
                                                variant={'standard'}
                                                fullWidth>
                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</FormLabel>
                                                <RadioGroup
                                                    row
                                                    defaultValue="active"
                                                    aria-labelledby="demo-customized-radios"
                                                    name="status"
                                                    value={form?.status || 'ACTIVE'}
                                                    onChange={(e) => changeHandler(e)}
                                                >
                                                    <FormControlLabel value="ACTIVE" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Active" />
                                                    <FormControlLabel value="INACTIVE" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="In-Active" />
                                                </RadioGroup>
                                            </FormControl>
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.hsnId || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["HSN Code"]}
                                                heads={[{ 'key': 'hsnCode', 'name': 'HSN Code' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={hsnDetails}
                                                parentValue={customObject(hsnDetails, form?.hsnId)}
                                                position={"top"}
                                                searchType={(s) => hsnApi(s)}
                                                topPosition={true}
                                                customClasses={classes.margin20t}
                                                onChange={(data) => changeHandler(data.id, 'hsnId')}
                                                parentError={error.hsnId}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {console.log(form)}
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Bar Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.barcode || '----'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Bar Code "]}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                name={"barcode"}
                                                fullWidth
                                                value={form?.barcode || ''}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IAN Number</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.ianNumber || '----'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["IAN Number"]}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                name={"ianNumber"}
                                                fullWidth
                                                value={form?.ianNumber || ''}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Space className={clsx(classes.customLink, classes.margin35t)}>
                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Prices</Typography>
                                    </Space>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {useMrp ? 'Yes' : 'No'}
                                                </Typography>
                                            </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                control={<Switch size='small'
                                                    name={'useMrp'}
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => changeHandler(!form.useMrp, 'useMrp')}
                                                    checked={form.useMrp}
                                                />}
                                                label="Use MRP"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {form?.mrp || '---'}
                                                </Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                title={"Enter the maximum allowed retail price for the item"}
                                                label='MRP'
                                                variant={'standard'}
                                                fullWidth
                                                className={clsx(classes.margin20t)}
                                                name={"mrp"}
                                                value={form.mrp}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                                error={error.mrp ? true : false}
                                                helperText={error.mrp}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={8}>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Includes Tax</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {form.priceIncludesTax ? 'Yes' : 'No'}
                                                </Typography>
                                            </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                control={<Switch size='small'
                                                    name={'priceIncludesTax'}
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => {
                                                        changeHandler(!form.priceIncludesTax, 'priceIncludesTax')
                                                    }}
                                                />}
                                                label="Price Includes Tax"
                                                checked={form?.priceIncludesTax || false}
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                            />
                                    }
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <div className={clsx(classes.dateAdjust)}>
                                        {
                                            view ?
                                                <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Latest Updated Date (MRP)</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {form.mrpLastUpdatedDate ? moment(form.mrpLastUpdatedDate).format('DD MMM YYYY') : '---'}
                                                    </Typography>
                                                </> :
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        allowKeyboardControl={false}
                                                        views={['year', 'month', 'day']}
                                                        value={form?.mrpLastUpdatedDate || null}
                                                        label={"Last Updated Date (MRP)"}
                                                        name={"mrpLastUpdatedDate"}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor
                                                            }
                                                        }}
                                                        className={classes.margin20t}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue) => { changeHandler(newValue, 'mrpLastUpdatedDate') }}
                                                        renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                                    />
                                                </LocalizationProvider>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)} >
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                productId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !productId &&
                                            <Button
                                                key="Add More"
                                                color="primary"
                                                variant="contained"
                                                onClick={(e) => handleAddMore(e)}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >Add More</Button>
                                        }
                                    </Space> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => { setView(false); onEdit(data); }}>Edit</NavLink>
                            }
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Universal Product'}
                type={"import"}
                details={productDetails}
                loader={productLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder); }}
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={productId} loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                name={product} url={'universal-products'}
                title={'Universal Products'} visible={deleteModal} />
        </React.Fragment>
    );
}

export default Products